// extracted by mini-css-extract-plugin
module.exports = {"recoveryPassword":"RecoveryPassword_recoveryPassword__lXzTI","subTitle":"RecoveryPassword_subTitle__0SwBU"};